export default "/build/frontend/fonts/vendor/@fontsource/inter/files/inter-vietnamese-400-normal.woff?96f8adc74b63e1a3655f89441a97f6a8";